<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <PageHeader
          :page="page"
          has-return
          left-side-class="col-xl-8"
          right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
        />
      </div>
      <div class="col-12">
        <div>
          <SectionTitle
            icon="fas fa-file-contract"
            content="Información de Catálogo"
            container-class="tag-badge-main-info mt-2 mb-2"
          />

          <board :details="detailsBoard" />

          <articles-list
            class="mt-3"
            :items-list="articlesList"
            @onSearch="(articleName) => requestAdditionalInfo(1, articleName)"
            @onAdd="
              (articleName, filterName) => onAddArticle(articleName, filterName)
            "
            @onEdit="
              (article, filterName) => onEditArticle(article, filterName)
            "
            @onDelete="
              (article, filterName) => deleteArticle(article, filterName)
            "
          />

          <Pagination
            v-if="pagination.totalItemCount > pagination.perPage"
            :data="pagination"
            :page-size="pagination.perPage"
            @pagination-go-page="requestAdditionalInfo"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import PageHeader from 'PageHeader';
import materialsService from '@/services/api/materialsEquipment.api.js';
import ArticlesList from './ArticlesList';
import Board from 'Board';
import Pagination from 'pagination';
import { getCatalogArticleSearchResult } from '@/modules/materials-equipment/api.js';
import alert from '@/mixin/alert.mixin';

export default {
  name: 'EditCatalog',
  mixins: [alert],
  components: {
    SectionTitle,
    PageHeader,
    Board,
    Pagination,
    ArticlesList,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-edit',
        title: 'Catálogo de Materiales y Equipos',
        routes: ['Inicio', 'PEI', 'Catálogo de Materiales y Equipos'],
      },
      pagination: {
        perPage: 20,
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 0,
        count: 0,
      },
      model: {
        saloonName: null,
        categoryName: null,
      },
      articlesList: [],
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    detailsBoard() {
      return [
        [
          {
            label: 'Tipo de Salón:',
            icon: 'fas fa-school',
            data: this.model.saloonName,
            cols: 'col-12 col-md',
          },
          {
            label: 'Categoría:',
            icon: 'fas fa-ballot-check',
            data: this.model.categoryName,
            cols: 'col-12 col-md',
          },
        ],
      ];
    },
    classroomTypeId() {
      return this.$route.params.classroomTypeId;
    },
    categoryId() {
      return this.$route.params.categoryId;
    },
  },
  async mounted() {
    this.initData();
    this.requestAdditionalInfo();
  },
  methods: {
    async initData() {
      const dataSaloonTypes = await materialsService.getSaloonTypes();
      this.model.saloonName = dataSaloonTypes.data.find(
        (c) => c.id == this.classroomTypeId
      ).name;

      const dataCategories = await materialsService.getCategories({
        saloonId: this.classroomTypeId,
      });

      this.model.categoryName = dataCategories.data.find(
        (c) => c.id == this.categoryId
      ).name;
    },
    async requestAdditionalInfo(page = 1, filterName = '') {
      this.pagination.currentPage = page;
      const mappedFilter = {
        saloonId: this.classroomTypeId,
        categoryId: this.categoryId,
        pageIndex: page,
        pageSize: this.pagination.perPage,
        articleName: filterName,
      };

      await getCatalogArticleSearchResult(mappedFilter).then((res) => {
        this.articlesList = res.data.data;
        this.pagination = {
          ...this.pagination,
          totalItemCount: res.data.totalItemCount,
          pageCount: res.data.pageCount,
          currentPage: res.data.currentPage,
          count: res.data.count,
        };
      });
    },
    async onAddArticle(articleName, filterName) {
      let self = this;
      const params = {
        saloonId: Number(this.classroomTypeId),
        categoryId: Number(this.categoryId),
        description: articleName,
      };
      materialsService
        .saveItemType(params)
        .then((res) => {
          if (res) {
            self.requestAdditionalInfo(1, filterName);
            self.ShowToast(
              'Proceso Exitoso',
              'El artículo ha sido añadido exitosamente.',
              'success'
            );
          }
        })
        .catch((error) => {
          if (error && error.response && error.response.data) {
            self.ShowToast('Error', error.response.data.message, 'error');
          }
        });
    },
    async onEditArticle(article, filterName) {
      let self = this;
      const params = {
        itemTypeId: article.id,
        description: article.name,
      };
      materialsService
        .saveItemType(params)
        .then((res) => {
          if (res) {
            self.requestAdditionalInfo(1, filterName);
            self.ShowToast(
              'Proceso Exitoso',
              'El artículo ha sido guardado exitosamente.',
              'success'
            );
          }
        })
        .catch((error) => {
          if (error && error.response && error.response.data) {
            self.ShowToast('Error', error.response.data.message, 'error');
          }
        });
    },
    async deleteArticle(article, filterName) {
      let self = this;
      materialsService
        .hasNewRequestsByItemType(article.id)
        .then((res) => {
          if (res.data) {
            self.ShowToast(
              'Alerta',
              `Para eliminar el artículo, debe eliminar el artículo de las solicitudes en estatus Nuevo.`,
              'error'
            );
          } else {
            self
              .ShowCancelModal(
                'Alerta',
                `¿Usted está seguro que desea eliminar el artículo "${article.name}"?`,
                'Sí',
                'No'
              )
              .then((res) => {
                if (res) {
                  materialsService.deleteItemType(article.id).then(() => {
                    self.ShowToast(
                      'Proceso Exitoso',
                      'El artículo ha sido eliminado exitosamente.',
                      'success'
                    );
                    this.requestAdditionalInfo(1, filterName);
                  });
                }
              });
          }
        })
        .catch((error) => {
          if (error && error.response && error.response.data) {
            this.ShowToast('Error', error.response.data.message, 'error');
          }
        });
    },
  },
};
</script>
<style scoped>
.read-only >>> input {
  pointer-events: none;
  cursor: not-allowed !important;
  background-color: #f8f8f8;
}
.section-information {
  background-color: #f5f5f5;
  margin-left: 0.1rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.height-fixed >>> .vs__dropdown-toggle {
  height: calc(1.5em + 0.75rem + 2px) !important;
}

::v-deep .text-title {
  font-size: 0.75rem !important;
  font-weight: normal !important;
}

@media only screen and (max-width: 375px) {
  ::v-deep .regular {
    font-size: 0.75rem !important;
    font-weight: normal !important;
  }

  ::v-deep .tag-badge-title-info {
    font-size: 0.75rem !important;
  }

  .section-title {
    width: 100% !important;
  }

  ::v-deep .input-display {
    font-size: 0.75rem;
  }

  ::v-deep .input-display > label {
    color: #727272 !important;
    font-weight: normal !important;
  }
}
</style>
